<template>
  <tr>
    <td v-for="(column, index) in columns" :key="column.name + index">
      <span
        v-if="column.action"
        class="column-action"
        @click="$emit(column.action, object)"
      >{{ column.translate ? $t(object[column.name]) : object[column.name] }}</span>

      <span v-else>{{ column.translate ? $t(object[column.name]) : object[column.name] }}</span>
    </td>

    <td v-if="actions.length > 0" class="actions">
      <check-permission
        v-for="(action, index) in actions"
        :key="action.name + '_' + index"
        :entityId="action.entityId ? action.entityId : object.id"
        :entityType="action.entityType ? action.entityType : entityType"
        :permissions="action.permissions ? action.permissions : getPermissions(action.permissionsTypes)"
      >
        <tooltip :text="$t(action.toolTipText)">
          <button
            class="btn btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2"
            :class="action.class ? action.class : 'btn-light'"
            :disabled="!!object[action.disabledIfField]"
            :style="'color: ' + action.color"
            @click.prevent="$emit(action.event, object)"
          >
            <i :class="action.icon" />
            {{ action.name }}
          </button>
        </tooltip>
      </check-permission>
    </td>
  </tr>
</template>

<script>
import Tooltip from '@/components/Tooltip';
// @vuese
// Rząd tabeli
export default {
  props: {
    columns: {
      type: Array,
      required: true
    },

    object: {
      type: Object,
      required: true
    },

    actions: {
      type: Array,
      required: false,
      default: false
    },
    entityType: {
      type: String,
      required: false
    }
  },
  components: {
    Tooltip
  },
  methods: {
    // @vuese
    // Ustawia uprawnienia przycisku akcji
    getPermissions(permissionsTypes) {
      return permissionsTypes.map(permissionType => `${this.entityType.toUpperCase()}.${permissionType}`);
    }
  }
};
</script>

<style>
.column-action {
  color: #27738d;
  text-decoration: underline;
}
.column-action:hover {
  cursor: pointer;
}
</style>
